import FeathersHelper from "../../helpers/feathers";

export const find = (payload) =>
  FeathersHelper.find('notifications', payload);
export const create = (payload) =>
  FeathersHelper.create('notifications', payload);
export const patch = (id, payload, params = {}) => FeathersHelper.patch('notifications', id, payload, params);
export const remove = (id, params = {}) => FeathersHelper.remove('notifications', id, params);

